// export const BASE_URL = "http://localhost:3001"; // local
export const BASE_URL = 'https://api.xscope-measure.com'; // production only